import DishesKitTableHeader from './DishesKitTableHeader';

export default DishesKitTableHeader;
